// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthMainText_content__Qvxpq","title":"AuthMainText_title__2_iak","subtitle":"AuthMainText_subtitle__Zia72"};